'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const InputSearchContainer = styled.div`
  width: 300px;
  min-width: 250px;
  max-width: 25%;
  justify-self: end;
  grid-column: 1;
  margin-right: 1.5rem;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${Spacers.LG}rem;
  gap: ${Spacers.LG}rem;
  height: 100%;
  width: 100%;
`;

export const TableContentWrapper = styled.div`
  width: 100%;
`;

export const TableSearchAndContentWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  grid-column: 1;
`;

export const TableHeader = styled.thead`
  background-color: ${(props) => props.theme.colors.actionActive};
`;

export const TableHeaderCell = styled.th`
  padding: ${Spacers.BASE}rem;
  text-align: left;
  font-size: ${(props) => props.theme.typography.title.fontSize};
  font-weight: ${(props) => props.theme.typography.title.fontWeight};
  line-height: ${(props) => props.theme.typography.title.lineHeight};
  border-bottom: 1px solid ${(props) => props.theme.colors.adminBorder};
  background-color: ${(props) => props.theme.colors.brandAccent};
`;

export const TableRow = styled.tr`
  cursor: pointer;
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.adminBorder};
  }
`;

export const TableCell = styled.td`
  padding: ${Spacers.BASE}rem;
  vertical-align: middle;
`;

export const StyledEyeIcon = styled.div`
  display: flex;
  align-items: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.actionDefault};

  &:hover {
    color: ${(props) => props.theme.colors.actionHover};
  }

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: ${Spacers.BASE}rem;
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};

  ${(props) => {
    switch (props.$status) {
      case 'created':
        return `background-color: ${props.theme.colors.backgroundAccent}; 
        color: ${props.theme.colors.typographyHeadersLight};`;
      case 'approved':
        return `background-color: ${props.theme.colors.statusSuccess}; 
        color: ${props.theme.colors.typographyHeadersDark};`;
      case 'pending':
        return `background-color: ${props.theme.colors.statusWarning}; 
        color: ${props.theme.colors.typographyHeadersDark};`;
      case 'disabled':
        return `background-color: ${props.theme.colors.backgroundAccent}; color: ${props.theme.colors.backgroundDark};`;
      default:
        return `background-color: ${props.theme.colors.backgroundAccent}; 
        color: ${props.theme.colors.typographyHeadersLight};`;
    }
  }}
`;

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
`;

export const PaginationButton = styled.button`
  padding: 0.5rem 1rem;
  border: 1px solid ${(props) => props.theme.colors.adminBorder};
  background-color: ${(props) => props.theme.colors.backgroundLight};
  color: ${(props) => props.theme.colors.typographyHeadersLight};
  cursor: pointer;
  border-radius: 0.5rem;
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.colors.actionHover};
    color: ${(props) => props.theme.colors.typographyHeadersDark};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PaginationInfo = styled.span`
  margin: 0 0.5rem;
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};
  color: ${(props) => props.theme.colors.typographyHeadersLight};
`;
